import useSWR from "swr";
import { fetcher } from "@/lib/api";
import { Seg } from "@/components/traffic/Widgets";

export function SiteSelect({ value, onChange, testId, allLabel = "All sites" }) {
  const { data } = useSWR("/traffic/sites", fetcher);
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId}
      className="h-8 rounded-full border border-border bg-background px-3 text-xs font-medium focus:outline-none focus:ring-2 focus:ring-ring">
      <option value="ALL">{allLabel}</option>
      {(data?.sites || []).map((s) => <option key={s.site_id} value={s.site_id}>{s.site_id} · {s.name}</option>)}
    </select>
  );
}

export function DateInput({ value, onChange, testId }) {
  return <input type="date" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId}
    className="h-8 rounded-full border border-border bg-background px-3 text-xs focus:outline-none focus:ring-2 focus:ring-ring" />;
}

export const localIso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const isoDay = (offset = 0) => { const d = new Date(); d.setDate(d.getDate() + offset); return localIso(d); };

// Shared period presets (Analytics, Incidents, Reports). Returns [start, end] as local ISO days.
export const RANGE_PRESETS = [
  { value: "today", label: "Today" }, { value: "7d", label: "Last 7 days" }, { value: "30d", label: "Last 30 days" },
  { value: "month", label: "This month" }, { value: "last_month", label: "Last month" }, { value: "2m", label: "Last 2 months" }, { value: "custom", label: "Custom" },
];
export function presetRange(p) {
  const d = new Date();
  if (p === "today") return [isoDay(0), isoDay(0)];
  if (p === "7d") return [isoDay(-6), isoDay(0)];
  if (p === "30d") return [isoDay(-29), isoDay(0)];
  if (p === "month") return [localIso(new Date(d.getFullYear(), d.getMonth(), 1)), isoDay(0)];
  if (p === "2m") return [localIso(new Date(d.getFullYear(), d.getMonth() - 2, 1)), localIso(new Date(d.getFullYear(), d.getMonth(), 0))];
  return [localIso(new Date(d.getFullYear(), d.getMonth() - 1, 1)), localIso(new Date(d.getFullYear(), d.getMonth(), 0))];
}

export function RangePicker({ preset, range, onChange, presets = RANGE_PRESETS, testId }) {
  return (
    <>
      <Seg value={preset} onChange={(p) => onChange(p, p === "custom" ? range : presetRange(p))} options={presets} testId={testId} />
      <DateInput value={range[0]} onChange={(v) => onChange("custom", [v, range[1]])} testId={`${testId}-start`} />
      <span className="text-xs text-muted-foreground">to</span>
      <DateInput value={range[1]} onChange={(v) => onChange("custom", [range[0], v])} testId={`${testId}-end`} />
    </>
  );
}
